import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { OleService } from 'src/app/services/ole.service';
import { ProjectComponent } from '../project/project.component';
import { TaskComponent } from '../Task/Task.component';
import { TopicComponent } from '../Topic/Topic.component';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Router } from '@angular/router';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
@Component({
  selector: 'app-Master-ole',
  templateUrl: './Master-ole.component.html',
  styleUrls: ['./Master-ole.component.scss']
})
export class MasterOleComponent implements OnInit {
  @ViewChild(ProjectComponent) ProjectComponent!: ProjectComponent;
  @ViewChild(TaskComponent) TaskComponent!: TaskComponent;
  @ViewChild(TopicComponent) TopicComponent!: TopicComponent;
  searchOleMasterForm!: FormGroup;
  plants!: any;
  groupListDDL!: any[];
  breadcrumList!: any;
  IsAccess!: any;
  IsWrite!: any;
  permisson!: any;
  lang: any;
  languageDir = 'ltr';
  pageId: any;
  moduleId: any;
  langObj: any;
  constructor( private fb: FormBuilder,private toaster: ToastrService,private OleService: OleService,private userManagementService: UserManagementService,public router: Router,private masterOleService: EnterPriseGroupService, private translater: TranslaterService, private translate: TranslateService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();})
   }

  ngOnInit() {
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.searchOleMasterForm = this.fb.group({
      group: ['', Validators.required],
      plant: ['', Validators.required],
    });
    this.getGroupData();
  }
  getGroupData(): void {
    const key = {
      Id: 0
    };
    // tslint:disable-next-line: no-debugger
    this.OleService.getGroupData(key).subscribe((data: any) => {
      this.groupListDDL = data.masterList;
      this.searchOleMasterForm.get('group')?.setValue(this.groupListDDL[0].TypeId);
      this.getPlantByGroup();
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }
  getPlantByGroup(): void {
    const key = {
      GroupId: this.searchOleMasterForm.get('group')?.value
    };
    // this.MachineId = null;
    this.OleService.getPlantsData(key).subscribe((data: any) => {
      this.plants = data.DepartList;
      this.searchOleMasterForm.get('plant')?.setValue(this.plants[0].DeptId);
      this.getMasterData();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }
  getMasterData(): void {
    const plant = this.searchOleMasterForm.get('plant')?.value;
    const group = this.searchOleMasterForm.get('group')?.value;
    const key = {
      plantId: plant,
      groupId: group
    };
    this.ProjectComponent.getProjectMaster(key);
    this.TopicComponent.getTopicMaster(key);
    this.TaskComponent.getTaskMaster(key);
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.userManagementService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length -1].id;
      console.log(data.BreadcrumList);
      this.getLangWords();
      this.lang = new Multilingual(this.translater,this.translate);
      this.lang.getLangWords();
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.masterOleService.GetMenuAccess(key).subscribe((data: any) => {
      this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  } 
}
